import Navbar from "../components/Navbar/Navbar";
import { Sidebar } from "../components/Sidebar";
import extractUrlToMenus from "../utils/extractUrlToMenus";
import { withRouter } from "../utils/withRouter";
import "./layout.css";

const HomeDashboardLayout = (props) => {
  let res = ["dashboard"];
  Object.values(props.routeParams).forEach((strEl) => {
    const exMenus = extractUrlToMenus(strEl);

    exMenus.forEach((sEl) => {
      if (!res.includes(sEl)) {
        res.push(sEl);
      }
    });
  });
  return (
    <>
      <Navbar className="container-fluid" type="dashboard" isLight />
      <div className="home-dashboard-layout-container ">
        {props.menus && props.menus.length > 0 && (
          <Sidebar {...props} menus={props.menus} />
        )}
        <div className="dashboard-layout">{props.children}</div>
      </div>
    </>
  );
};

export default withRouter(HomeDashboardLayout);
